'use client'
import React from 'react'
import { TableCell } from './TableCell'
import { ContextMenu } from '../../../molecules/ContextMenu/ContextMenu'

export interface TableRowActionsProps {
    children: React.ReactNode
}

export const TableRowActions = ({ children, ...props }: TableRowActionsProps) => {
    return (
        <TableCell {...props} hasNoPadding>
            <ContextMenu>{children}</ContextMenu>
        </TableCell>
    )
}
